import {
  Card,
  Container,
  Stack,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
  Alert,
  TextField,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  FormControlLabel,
  Checkbox,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import api from '../utils/api';
import { settingsSelector, getSettings } from '../slices/settingsSlice';
import { ApiStatus, TipResult } from '../utils/constants';
import Page from '../components/Page';

function CapperDetails() {
  const { id: userId } = useParams();
  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(false);

  const { settings, status } = useSelector(settingsSelector);
  const dispatch = useDispatch();

  const [capper, setcapper] = useState(null);
  const [selectedBadges, setSelectedBadges] = useState([]);

  useEffect(() => {
    fetch();
    dispatch(getSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetch = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/user/capperDetails`, { id: userId });
      setcapper(response.capper);
      setSelectedBadges(response.capper.badges);
    } catch (e) {
      console.log(e.toString());
      setErrorMessage(e.toString());
    }
    setLoading(false);
  };

  const saveBadges = async () => {
    setLoading(true);
    try {
      await api.post(`/user/setBadges`, { id: userId, badges: selectedBadges });
    } catch (e) {
      console.log(e.toString());
      setErrorMessage(e.toString());
    }
    setLoading(false);
  };

  const isChecked = (badgeName) => selectedBadges.indexOf(badgeName) > -1;

  const _buildCapperDetails = () => (
    <Stack padding={2} spacing={1}>
      <Typography variant="caption">{capper.username}</Typography>
      <Typography variant="caption">{capper.email}</Typography>
      <Stack direction="row" spacing={1} paddingTop={2} paddingBottom={2}>
        <Typography variant="body1">Current Amount {capper.capperCurrentAmount}$</Typography>
        <Button variant="contained">Pay Capper</Button>
      </Stack>

      <Stack direction="row" spacing={1} paddingTop={2} paddingBottom={2}>
        <TextField
          id="outlined-basic"
          label="Capper Payout %"
          variant="outlined"
          defaultValue={capper.capperPayout * 100}
        />
        <Button variant="contained">Save Payout</Button>
      </Stack>

      <div>
        <TableContainer component={Paper}>
          <Table size="small" sx={{ width: '200px' }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Total Tips</TableCell>
                <TableCell align="right">{capper.tips.length}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow key="pending" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  Pending
                </TableCell>
                <TableCell align="right">
                  {capper.tips.filter((e) => e.result === TipResult.pending).length}
                </TableCell>
              </TableRow>
              <TableRow key="success" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  Successful
                </TableCell>
                <TableCell align="right">
                  {capper.tips.filter((e) => e.result === TipResult.success).length}
                </TableCell>
              </TableRow>
              <TableRow key="failed" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  failed
                </TableCell>
                <TableCell align="right">
                  {capper.tips.filter((e) => e.result === TipResult.failure).length}
                </TableCell>
              </TableRow>
              <TableRow key="Push" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  Push
                </TableCell>
                <TableCell align="right">
                  {capper.tips.filter((e) => e.result === TipResult.push).length}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Typography variant="caption">All Time: {capper.capperAllTimeAmount}$</Typography>
      <Typography variant="caption">Total Payments made: {capper.capperAllTimePayout}$</Typography>
    </Stack>
  );

  const _buildBadges = () => (
    <Card style={{ padding: '20px', marginTop: '20px' }}>
      <List>
        {settings.badges.map((e) => (
          <ListItem
            key={e.name}
            secondaryAction={
              <Checkbox
                edge="end"
                onChange={() => {
                  if (selectedBadges.length > 2) {
                    setErrorMessage('Only three badges allowed per capper');
                    return;
                  }

                  let badges = [];
                  if (isChecked(e.name)) {
                    badges = selectedBadges.filter((t) => t !== e.name);
                  } else {
                    badges = [...selectedBadges, e.name];
                  }
                  setSelectedBadges(badges);
                  console.log(badges);
                }}
                checked={isChecked(e.name)}
                inputProps={{ 'aria-labelledby': `checkbox-list-secondary-label-${e.name}` }}
              />
            }
            disablePadding
          >
            <ListItemButton>
              <ListItemAvatar>
                <Avatar
                  alt=""
                  src={`${process.env.REACT_APP_IMAGE_URL}/api/images/badges/${e.image}`}
                />
              </ListItemAvatar>
              <ListItemText id={`checkbox-list-secondary-label-${e.name}`} primary={e.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Button onClick={saveBadges} variant="contained">
        Save
      </Button>
    </Card>
  );

  return (
    <Page title="Cappers">
      <Backdrop
        style={{ zIndex: 100, color: '#fff' }}
        open={loading || status === ApiStatus.loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {errorMessage && errorMessage.length && <Alert severity="error">{errorMessage}</Alert>}
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {capper ? capper.name : 'loading'}
          </Typography>
        </Stack>
        <Card>{capper && _buildCapperDetails()}</Card>
        {_buildBadges()}
      </Container>
    </Page>
  );
}
export default CapperDetails;
